import Layout from "@/layout/Layout";
import React, {useEffect, useState} from "react";
import {User} from "@/entity/User";
import {me} from "@/api";
import ProfileViewer from "@/components/ProfileViewer";
import globalStyle from '@/styles/Global.scss'
import MButton from "@/components/atom/MButton";
import {useHistory} from "react-router";

const Profile = () => {
  const history = useHistory()
  const [user, setUser] = useState(new User({}))

  useEffect(() => {
    (async () => {
      setUser(new User(await me()))
    })()
  }, [])

  const toEdit = () => {
    history.push(`/profile/edit`)
  }

  const goBack = () => {
    history.push(`/setting`)
  }

  return (<>
    <Layout title={'プロフィール'}>
      <div>
        <ProfileViewer user={user}></ProfileViewer>
      </div>
      <div className={globalStyle.attribute}>
        <MButton image={'edit.png'} value={'編集'} onClick={toEdit}></MButton>
        <MButton image={'back.png'} value={'戻る'} onClick={goBack}></MButton>
      </div>
    </Layout>
  </>)
}

export default Profile
